import Users from '@/apiClient/Users'
import { SET_BOARDS } from './mutations-types'
import { assign, map } from 'lodash'

const User = new Users()

const actions = {
  setInitialBoards: async ({ commit }) => {
    const activeBoardsResponse = await User.getActiveBoards()

    if (activeBoardsResponse.data.results.data.length === 0) {
      return commit(SET_BOARDS, [])
    }

    const activeBoards = activeBoardsResponse.data.results.data

    const boardPromises = map(activeBoards, async board => {
      if (board.archivo) {
        const response = await User.getDocumentBoard(board.id)
        const data_uri_prefix = 'data:image/*;base64,'
        const image = {
          imageDecode: data_uri_prefix + response,
          imageBase64: response,
          page: 1,
          totalPages: undefined,
          adviseToZoom: true
        }
        board.archivo = assign(board.archivo, image)
        return board
      }
      return board
    })

    const responses = await Promise.all(boardPromises)

    commit(SET_BOARDS, responses)
  }
}

export default actions
